// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { GenericDocsAddDocDialogComponent } from 'src/app/modules/generic-docs/components/add-doc-dialog/add-doc-dialog.component';
import { GenericDocsEditDocDialogComponent } from 'src/app/modules/generic-docs/components/edit-doc-dialog/edit-doc-dialog.component';
import { GenericDocsQrCodeDialogComponent } from 'src/app/modules/generic-docs/components/qr-code-dialog/qr-code-dialog.component';
import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';
import { GenericDocsRoutingModule } from './generic-docs-routing.module';

// Custom packages - Components
import { GenericDocsListComponent } from './pages/generic-docs-list.page';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    GenericDocsRoutingModule,
    PublicModule,
  ],
  declarations: [
    GenericDocsListComponent,
    GenericDocsAddDocDialogComponent,
    GenericDocsEditDocDialogComponent,
    GenericDocsQrCodeDialogComponent,
  ],
  entryComponents: [
    GenericDocsAddDocDialogComponent,
    GenericDocsEditDocDialogComponent,
    GenericDocsQrCodeDialogComponent,
  ],
  exports: [
    GenericDocsAddDocDialogComponent,
    GenericDocsEditDocDialogComponent,
    GenericDocsQrCodeDialogComponent,
  ]
})
export class GenericDocsModule { }
